<template>
  <div class="ai-report-bi">
    <div v-if="reportParams && reportParams.size && reportParams.sortFieldDesc" class="report-tips">
      本报表提取「{{ reportParams.sortFieldDesc }}」前{{ reportParams.size }}条数据用于分析
    </div>
    <!-- 可以在这里使用映射渲染对应的组件 -->
    <component
      :is="currentComponent"
      v-if="currentComponent"
      :table-data="tableData"
      :dataType="dataType"
      :key="currentComponent"
      :maxHeight="maxHeight"
      :payTimeStart="payTimeStart"
      :payTimeEnd="payTimeEnd"
      :reportParams="reportParams"
      :currentPath="currentPath"
    />
  </div>
</template>

<script>
// 销售分析
import STORE_SALES from "./prefabricateReport/reviewReport/salesAnalysis/salesAnalysisQuery.vue";
import AREA_SALES from "./prefabricateReport/marketAnalysis/region_distribution_analysis.vue";
import CLASS_CITY_SALES from "./prefabricateReport/marketAnalysis/tiercity_analysis.vue";
import TOP10_PRODUCT_SALES_SKU from "./prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue";
import TOP10_PRODUCT_SALES_SPU from "./prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue";
import TOP10_PRODUCT_SALES_CATEGORY from "./prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue";
import TOP10_PRODUCT_SALES_STORE_CATEGORY from "./prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue";
import TOP10_PRODUCT_SALES_CUSTOM_CATEGORY from "./prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue";
import TOP10_PRODUCT_SALES_TAG from "./prefabricateReport/reviewReport/salesAnalysis/marketAnalysis/marketAnalysisCom.vue";
import THEME_TYPE_SALES from "./prefabricateReport/reviewReport/salesAnalysis/douyinAnalysis/orderAndTrafficSource.vue";
import CBIZ_SALES from "./prefabricateReport/reviewReport/salesAnalysis/douyinAnalysis/orderAndTrafficSource.vue";
import AUTHOR_SALES from "./prefabricateReport/reviewReport/salesAnalysis/douyinAnalysis/anchorTrading.vue";
import ROOM_SALES from "./prefabricateReport/reviewReport/salesAnalysis/douyinAnalysis/liveAndVideoSource.vue";
import VIDEO_SALES from "./prefabricateReport/reviewReport/salesAnalysis/douyinAnalysis/liveAndVideoSource.vue";

// 客户分析
import RETENTION from "./prefabricateReport/reviewReport/customerAnalysis/retentionRateAnalysis.vue";
import TOP10_RETENTION_ANALYSIS_SKU from "./prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue";
import TOP10_RETENTION_ANALYSIS_SPU from "./prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue";
import TOP10_RETENTION_ANALYSIS_CATEGORY from "./prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue";
import TOP10_RETENTION_ANALYSIS_STORE_CATEGORY from "./prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue";
import TOP10_RETENTION_ANALYSIS_TAG from "./prefabricateReport/reviewReport/customerAnalysis/retentionAnalysis/retentionCom.vue";
import CUSTOMER_LIFE_CYCLE from "./prefabricateReport/reviewReport/customerAnalysis/customerLifecycle.vue";
import ITEM_PRICE_ANALYSIS from "./prefabricateReport/reviewReport/customerAnalysis/itemPriceAnalysis.vue";
import PURCHASE_AMOUNT from "./prefabricateReport/reviewReport/customerAnalysis/purchaseAmountcleAnalysis.vue";
import PURCHASE_FREQUENCY from "./prefabricateReport/reviewReport/customerAnalysis/purchaseCountAnalysis.vue";
import AVG_ORDER_VALUE from "./prefabricateReport/reviewReport/customerAnalysis/customerPriceAnalysis.vue";
import REPURCHASE_CYCLE from "./prefabricateReport/reviewReport/customerAnalysis/repurchaseAnalysis.vue";
import CUSTOMER_REPURCHASE_TIME from "./prefabricateReport/reviewReport/customerAnalysis/lifecycleAnalysis.vue";
import CUSTOMER_REPURCHASE from "./prefabricateReport/reviewReport/customerAnalysis/customerRepurchaseItemTag.vue";

// 会员分析
import MEMBER_OVERVIEW from "./prefabricateReport/reviewReport/memberAnalysis/memberOverviewAnalysis.vue";
import MEMBER_RECRUIT_JD from "./prefabricateReport/reviewReport/memberAnalysis/jdMembershipRecruitment.vue";
import MEMBER_RECRUIT_TB from "./prefabricateReport/reviewReport/memberAnalysis/tbMembershipRecruitment.vue";
import MEMBER_LEVEL_ANALYSIS from "./prefabricateReport/reviewReport/memberAnalysis/memberLevelAnalysis.vue";
import MEMBER_LEVEL_HYT_ANALYSIS from "./prefabricateReport/reviewReport/memberAnalysis/memberLevelHytAnalysis.vue";
import MEMBER_GRADE_AREA_ANALYSIS from "./prefabricateReport/reviewReport/memberAnalysis/memberGradeAreaAnalysis.vue";
import MEMBER_POINTS_ANALYSIS from "./prefabricateReport/reviewReport/memberAnalysis/memberPointsAnalysis.vue";
import POINTS_CHANGE_ANALYSIS from "./prefabricateReport/reviewReport/memberAnalysis/pointsChangeAnalysis.vue";
import MEMBER_LIFE_CYCLE from "./prefabricateReport/reviewReport/memberAnalysis/memberLifecycle.vue";
import MEMBER_ITEM_PRICE_ANALYSIS from "./prefabricateReport/reviewReport/memberAnalysis/rankItemPrice.vue";
import MEMBER_GRADE_PURCHASE_AMOUNT from "./prefabricateReport/reviewReport/memberAnalysis/rankPurchaseAmount.vue";
import MEMBER_GRADE_PURCHASE_FREQUENCY from "./prefabricateReport/reviewReport/memberAnalysis/rankPurchaseCount.vue";
import MEMBER_GRADE_AVG_ORDER_VALUE from "./prefabricateReport/reviewReport/memberAnalysis/rankPurchasePrice.vue";
import MEMBER_GRADE_REPURCHASE_CYCLE from "./prefabricateReport/reviewReport/memberAnalysis/rankPurchaseCycle.vue";

// 关联分析
import TOP10_PRODUCT_ASSOCIATION_SKU from "./prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue";
import TOP10_PRODUCT_ASSOCIATION_SPU from "./prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue";
import TOP10_PRODUCT_ASSOCIATION_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue";
import TOP10_PRODUCT_ASSOCIATION_STORE_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue";
import TOP10_PRODUCT_ASSOCIATION_TAG from "./prefabricateReport/reviewReport/associationAnalysis/sameCountAssociation/sameCountCom.vue";
import TOP10_REPURCHASE_ASSOCIATION_SKU from "./prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue";
import TOP10_REPURCHASE_ASSOCIATION_SPU from "./prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue";
import TOP10_REPURCHASE_ASSOCIATION_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue";
import TOP10_REPURCHASE_ASSOCIATION_STORE_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue";
import TOP10_REPURCHASE_ASSOCIATION_TAG from "./prefabricateReport/reviewReport/associationAnalysis/repurchaseAssociation/repurchaseCom.vue";
import TOP10_CROSS_ASSOCIATION_SKU from "./prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue";
import TOP10_CROSS_ASSOCIATION_SPU from "./prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue";
import TOP10_CROSS_ASSOCIATION_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue";
import TOP10_CROSS_ASSOCIATION_STORE_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue";
import TOP10_CROSS_ASSOCIATION_TAG from "./prefabricateReport/reviewReport/associationAnalysis/intersectionAssociation/intersectionCom.vue";
import TOP10_PRESALES_ASSOCIATION_SKU from "./prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue";
import TOP10_PRESALES_ASSOCIATION_SPU from "./prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue";
import TOP10_PRESALES_ASSOCIATION_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue";
import TOP10_PRESALES_ASSOCIATION_STORE_CATEGORY from "./prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue";
import TOP10_PRESALES_ASSOCIATION_TAG from "./prefabricateReport/reviewReport/associationAnalysis/preSalesAssociation/preSalesCom.vue";

// 复购分析
import TOP10_SAME_PRODUCT_REPURCHASE_SKU from "./prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue";
import TOP10_SAME_PRODUCT_REPURCHASE_SPU from "./prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue";
import TOP10_SAME_PRODUCT_REPURCHASE_CATEGORY from "./prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue";
import TOP10_SAME_PRODUCT_REPURCHASE_STORE_CATEGORY from "./prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue";
import TOP10_SAME_PRODUCT_REPURCHASE_TAG from "./prefabricateReport/reviewReport/repurchaseAnalysis/sameProduct/sameProductCom.vue";
import TOP10_STORE_REPURCHASE_SKU from "./prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue";
import TOP10_STORE_REPURCHASE_SPU from "./prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue";
import TOP10_STORE_REPURCHASE_CATEGORY from "./prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue";
import TOP10_STORE_REPURCHASE_STORE_CATEGORY from "./prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue";
import TOP10_STORE_REPURCHASE_TAG from "./prefabricateReport/reviewReport/repurchaseAnalysis/repurchaseStoreProduct/storeProductCom.vue";

// 购买分布
import TOP10_ITEM_PURCHASE_FREQUENCY_SKU from "./prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue";
import TOP10_ITEM_PURCHASE_FREQUENCY_SPU from "./prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue";
import TOP10_ITEM_PURCHASE_FREQUENCY_CATEGORY from "./prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue";
import TOP10_ITEM_PURCHASE_FREQUENCY_STORE_CATEGORY from "./prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue";
import TOP10_ITEM_PURCHASE_FREQUENCY_TAG from "./prefabricateReport/reviewReport/buyDistribution/buyFrequency/buyFrequencyCom.vue";

export default {
  name: "AiReportBI",
  components: {
    // 销售分析
    STORE_SALES,
    AREA_SALES,
    CLASS_CITY_SALES,
    TOP10_PRODUCT_SALES_SKU,
    TOP10_PRODUCT_SALES_SPU,
    TOP10_PRODUCT_SALES_CATEGORY,
    TOP10_PRODUCT_SALES_STORE_CATEGORY,
    TOP10_PRODUCT_SALES_CUSTOM_CATEGORY,
    TOP10_PRODUCT_SALES_TAG,
    THEME_TYPE_SALES,
    CBIZ_SALES,
    AUTHOR_SALES,
    ROOM_SALES,
    VIDEO_SALES,
    // 客户分析
    RETENTION,
    TOP10_RETENTION_ANALYSIS_SKU,
    TOP10_RETENTION_ANALYSIS_SPU,
    TOP10_RETENTION_ANALYSIS_CATEGORY,
    TOP10_RETENTION_ANALYSIS_STORE_CATEGORY,
    TOP10_RETENTION_ANALYSIS_TAG,
    CUSTOMER_LIFE_CYCLE,
    ITEM_PRICE_ANALYSIS,
    PURCHASE_AMOUNT,
    PURCHASE_FREQUENCY,
    AVG_ORDER_VALUE,
    REPURCHASE_CYCLE,
    CUSTOMER_REPURCHASE_TIME,
    CUSTOMER_REPURCHASE,
    // 会员分析
    MEMBER_OVERVIEW,
    MEMBER_RECRUIT_JD,
    MEMBER_RECRUIT_TB,
    MEMBER_LEVEL_ANALYSIS,
    MEMBER_LEVEL_HYT_ANALYSIS,
    MEMBER_GRADE_AREA_ANALYSIS,
    MEMBER_POINTS_ANALYSIS,
    POINTS_CHANGE_ANALYSIS,
    MEMBER_LIFE_CYCLE,
    MEMBER_ITEM_PRICE_ANALYSIS,
    MEMBER_GRADE_PURCHASE_AMOUNT,
    MEMBER_GRADE_PURCHASE_FREQUENCY,
    MEMBER_GRADE_AVG_ORDER_VALUE,
    MEMBER_GRADE_REPURCHASE_CYCLE,
    // 关联分析
    TOP10_PRODUCT_ASSOCIATION_SKU,
    TOP10_PRODUCT_ASSOCIATION_SPU,
    TOP10_PRODUCT_ASSOCIATION_CATEGORY,
    TOP10_PRODUCT_ASSOCIATION_STORE_CATEGORY,
    TOP10_PRODUCT_ASSOCIATION_TAG,
    TOP10_REPURCHASE_ASSOCIATION_SKU,
    TOP10_REPURCHASE_ASSOCIATION_SPU,
    TOP10_REPURCHASE_ASSOCIATION_CATEGORY,
    TOP10_REPURCHASE_ASSOCIATION_STORE_CATEGORY,
    TOP10_REPURCHASE_ASSOCIATION_TAG,
    TOP10_CROSS_ASSOCIATION_SKU,
    TOP10_CROSS_ASSOCIATION_SPU,
    TOP10_CROSS_ASSOCIATION_CATEGORY,
    TOP10_CROSS_ASSOCIATION_STORE_CATEGORY,
    TOP10_CROSS_ASSOCIATION_TAG,
    TOP10_PRESALES_ASSOCIATION_SKU,
    TOP10_PRESALES_ASSOCIATION_SPU,
    TOP10_PRESALES_ASSOCIATION_CATEGORY,
    TOP10_PRESALES_ASSOCIATION_STORE_CATEGORY,
    TOP10_PRESALES_ASSOCIATION_TAG,
    // 复购分析
    TOP10_SAME_PRODUCT_REPURCHASE_SKU,
    TOP10_SAME_PRODUCT_REPURCHASE_SPU,
    TOP10_SAME_PRODUCT_REPURCHASE_CATEGORY,
    TOP10_SAME_PRODUCT_REPURCHASE_STORE_CATEGORY,
    TOP10_SAME_PRODUCT_REPURCHASE_TAG,
    TOP10_STORE_REPURCHASE_SKU,
    TOP10_STORE_REPURCHASE_SPU,
    TOP10_STORE_REPURCHASE_CATEGORY,
    TOP10_STORE_REPURCHASE_STORE_CATEGORY,
    TOP10_STORE_REPURCHASE_TAG,
    // 购买分布
    TOP10_ITEM_PURCHASE_FREQUENCY_SKU,
    TOP10_ITEM_PURCHASE_FREQUENCY_SPU,
    TOP10_ITEM_PURCHASE_FREQUENCY_CATEGORY,
    TOP10_ITEM_PURCHASE_FREQUENCY_STORE_CATEGORY,
    TOP10_ITEM_PURCHASE_FREQUENCY_TAG,
  },
  props: {
    // 可以通过 prop 传入当前的 path
    currentPath: {
      type: String,
      default: "",
    },
    reportList: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: String,
      default: "500px",
    },
  },
  data() {
    return {};
  },
  computed: {
    currentComponent() {
      if (this.currentPath && this.$options.components[this.currentPath]) {
        return this.currentPath;
      }
      return null;
    },
    tableData() {
      // 从 reportList 中根据 currentPath 获取对应的数据
      const reportItem = this.reportList.find(
        (item) => item.reportType === this.currentPath
      );
      if (reportItem && reportItem.reportData) {
        try {
          const parsedData =
            typeof reportItem.reportData === "string"
              ? JSON.parse(reportItem.reportData)
              : reportItem.reportData;
          return parsedData;
        } catch (e) {}
      }
    },
    dataType() {
      if (
        [
          "TOP10_PRODUCT_SALES_SKU",
          "TOP10_PRODUCT_ASSOCIATION_SKU",
          "TOP10_REPURCHASE_ASSOCIATION_SKU",
          "TOP10_CROSS_ASSOCIATION_SKU",
          "TOP10_SAME_PRODUCT_REPURCHASE_SKU",
          "TOP10_STORE_REPURCHASE_SKU",
          "TOP10_PRESALES_ASSOCIATION_SKU",
          "TOP10_RETENTION_ANALYSIS_SKU",
          "TOP10_ITEM_PURCHASE_FREQUENCY_SKU",
        ].includes(this.currentPath)
      ) {
        return "sku";
      } else if (
        [
          "TOP10_PRODUCT_SALES_SPU",
          "TOP10_PRODUCT_ASSOCIATION_SPU",
          "TOP10_REPURCHASE_ASSOCIATION_SPU",
          "TOP10_CROSS_ASSOCIATION_SPU",
          "TOP10_SAME_PRODUCT_REPURCHASE_SPU",
          "TOP10_STORE_REPURCHASE_SPU",
          "TOP10_PRESALES_ASSOCIATION_SPU",
          "TOP10_RETENTION_ANALYSIS_SPU",
          "TOP10_ITEM_PURCHASE_FREQUENCY_SPU",
        ].includes(this.currentPath)
      ) {
        return "spu";
      } else if (
        [
          "TOP10_PRODUCT_SALES_CATEGORY",
          "TOP10_PRODUCT_ASSOCIATION_CATEGORY",
          "TOP10_REPURCHASE_ASSOCIATION_CATEGORY",
          "TOP10_CROSS_ASSOCIATION_CATEGORY",
          "TOP10_SAME_PRODUCT_REPURCHASE_CATEGORY",
          "TOP10_STORE_REPURCHASE_CATEGORY",
          "TOP10_PRESALES_ASSOCIATION_CATEGORY",
          "TOP10_RETENTION_ANALYSIS_CATEGORY",
          "TOP10_ITEM_PURCHASE_FREQUENCY_CATEGORY",
        ].includes(this.currentPath)
      ) {
        return "category";
      } else if (
        [
          "TOP10_PRODUCT_SALES_STORE_CATEGORY",
          "TOP10_PRODUCT_ASSOCIATION_STORE_CATEGORY",
          "TOP10_REPURCHASE_ASSOCIATION_STORE_CATEGORY",
          "TOP10_CROSS_ASSOCIATION_STORE_CATEGORY",
          "TOP10_SAME_PRODUCT_REPURCHASE_STORE_CATEGORY",
          "TOP10_STORE_REPURCHASE_STORE_CATEGORY",
          "TOP10_PRESALES_ASSOCIATION_STORE_CATEGORY",
          "TOP10_RETENTION_ANALYSIS_STORE_CATEGORY",
          "TOP10_ITEM_PURCHASE_FREQUENCY_STORE_CATEGORY",
        ].includes(this.currentPath)
      ) {
        return "sellerCategory";
      } else if (
        [
          "TOP10_PRODUCT_SALES_TAG",
          "TOP10_PRODUCT_ASSOCIATION_TAG",
          "TOP10_REPURCHASE_ASSOCIATION_TAG",
          "TOP10_CROSS_ASSOCIATION_TAG",
          "TOP10_SAME_PRODUCT_REPURCHASE_TAG",
          "TOP10_STORE_REPURCHASE_TAG",
          "TOP10_PRESALES_ASSOCIATION_TAG",
          "TOP10_RETENTION_ANALYSIS_TAG",
          "TOP10_ITEM_PURCHASE_FREQUENCY_TAG",
        ].includes(this.currentPath)
      ) {
        return "itemTag";
      } else if(['TOP10_PRODUCT_SALES_CUSTOM_CATEGORY'].includes(this.currentPath)){
        return "customCategory";
      }
    },
    payTimeStart() {
      if (this.reportList && this.reportList.length) {
        if (this.reportList[0].date) {
          return this.reportList[0].date.split("至")[0] + " 00:00:00";
        }
      }
    },
    payTimeEnd() {
      if (this.reportList && this.reportList.length) {
        if (this.reportList[0].date) {
          return this.reportList[0].date.split("至")[1] + " 23:59:59";
        }
      }
    },
    reportParams(){
       // 从 reportList 中根据 currentPath 获取对应的数据
      const reportItem = this.reportList.find(
        (item) => item.reportType === this.currentPath
      );
      if (reportItem && reportItem.reportParams) {
        try {
          const parsedData =
            typeof reportItem.reportParams === "string"
              ? JSON.parse(reportItem.reportParams)
              : reportItem.reportParams;
          return parsedData;
        } catch (e) {}
      }
      return {};
    }
  },
};
</script>

<style scoped>
.ai-report-bi {
  width: 100%;
  height: 100%;
}
.report-tips{
  margin-bottom: 10px;
}
</style>
